// removed by extract-text-webpack-plugin
module.exports = {"promo-left-padding":"PromoPanel__promo-left-padding","promoLeftPadding":"PromoPanel__promo-left-padding","promo-container":"PromoPanel__promo-container","promoContainer":"PromoPanel__promo-container","inner-divider":"PromoPanel__inner-divider","innerDivider":"PromoPanel__inner-divider","acc_promo_link":"PromoPanel__acc_promo_link","accPromoLink":"PromoPanel__acc_promo_link","static-content":"PromoPanel__static-content","staticContent":"PromoPanel__static-content"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/PromoPanel.scss
// module id = 411
// module chunks = 8